import React, { useEffect, useState, useContext } from "react"
import {PrimaryCard, SecondaryCard } from "../../components/cards";
import productShortName from "../../../../utils/GetProductShortName";
import useIsMounted from "../../../../hooks/useIsMounted";
import { CurrencyLabel } from "../../../common/inputs";
import useApi from '../../../../hooks/useApi';
import widgetService from "../../../../services/invTransactions";
import EntityContext from "../../../../context/entityContext";

export default function ApprovedScheduledSummary({ reloadKey = 0 }){

    const isMounted = useIsMounted();
    const { selectedBusinessType, selProduct, entityDetails } = useContext(EntityContext);
    const [data, setData] = useState(null);

    //------------Api Services-----------------------------------
    const approvedInvoicesApi = useApi(widgetService.getApprovedScheduledSummary);

    const fetchApprovedInvoices = async () => {
        const response = await approvedInvoicesApi.request({ entity_id: entityDetails.a_guid, selectedBusinessType });
        const summary = response?.data?.data;
        if(summary && isMounted()){
            setData({
                topLabel: "Approved And Scheduled",
                topValue: <CurrencyLabel decimal={2} value={summary.total_inv_amt} />,
                leftLabel: summary.isPrimary ? "Debtors" : "Clients",
                leftValue: summary.isPrimary ? summary.debtor_count : summary.client_count,
                rightLabel: "Invoices",
                rightValue: summary.invoice_count,
                bottomRightLabel: "",
                primaryBtnRoute: `/client/${productShortName(selProduct)}/sale-invoices?status=approved_for_payment`
            })
        }
    }

    useEffect(() => {
        fetchApprovedInvoices();
    }, [selectedBusinessType, entityDetails, reloadKey])

    return(
        <>
            <SecondaryCard
                loading={approvedInvoicesApi.loading}
                data={data}
                qrystring={true}
            />
        </>
    )
}